import API from "../helpers/API";

export default function useAPI () {
    return new API();
};